import DetailsProfessionalComponent from '../components/DetailsProfessional/DetailsProfessional';
import Navbar from '../components/Navbar/Navbar';

export default function DetailsProfessional() {
    return (
        <div>
            <Navbar/>
            <DetailsProfessionalComponent/>
        </div>
    )
}